import * as Types from "../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddBankMutationVariables = Types.Exact<{
  name: Types.Scalars["String"];
  address?: Types.Maybe<Types.Scalars["String"]>;
  regulator?: Types.Maybe<Types.Scalars["String"]>;
  ownership?: Types.Maybe<Types.Scalars["String"]>;
  notes?: Types.Maybe<Types.Scalars["String"]>;
}>;

export type AddBankMutation = { __typename?: "mutation_root" } & {
  insert_banks?: Types.Maybe<
    { __typename?: "banks_mutation_response" } & {
      returning: Array<
        { __typename?: "banks" } & Pick<Types.Banks, "id" | "name">
      >;
    }
  >;
};

export const AddBankDocument = gql`
  mutation AddBank(
    $name: String!
    $address: String
    $regulator: String
    $ownership: String
    $notes: String
  ) {
    insert_banks(
      objects: {
        name: $name
        address: $address
        regulator: $regulator
        ownership: $ownership
        notes: $notes
      }
    ) {
      returning {
        id
        name
      }
    }
  }
`;

export function useAddBankMutation() {
  return Urql.useMutation<AddBankMutation, AddBankMutationVariables>(
    AddBankDocument
  );
}
